import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgMilitaryDiscountSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.25a6.75 6.75 0 0 0-4.75 11.546V21a.75.75 0 0 0 .932.728L12 20.773l3.818.955A.75.75 0 0 0 16.75 21v-7.204A6.75 6.75 0 0 0 12 2.25ZM8.75 20.04v-5.123c.965.531 2.073.833 3.25.833a6.724 6.724 0 0 0 3.25-.833v5.122l-3.068-.767a.749.749 0 0 0-.364 0l-3.068.767ZM9.25 7a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H10A.75.75 0 0 1 9.25 7Zm4.22-.53a.75.75 0 1 1 1.061 1.06l-4 4a.75.75 0 1 1-1.06-1.06l4-4ZM13.24 11a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Z",
  fill: "currentColor"
})));

export { SvgMilitaryDiscountSolid as default };
